export default __webpack_public_path__ + "static/media/send-feedback.06586498.svg";